import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.002 6.868 24 7v21a1 1 0 0 1-1.458.89l-.097-.058L20 27.202l-2.445 1.63a1 1 0 0 1-.873.116l-.121-.05-.116-.066L14 27.202l-2.445 1.63a1 1 0 0 1-.873.116l-.121-.05-.116-.066L8 27.202l-2.445 1.63c-.6.4-1.383.051-1.53-.608l-.02-.112L4 28V7a3 3 0 0 1 2.824-2.995L7 4h18a3 3 0 0 1 2.995 2.824L28 7v10a1 1 0 0 1-1.993.117L26 17V7a1 1 0 0 0-.883-.993L25 6c-.69 0-.94.17-.99.747zM22.122 6H7a1 1 0 0 0-.993.883L6 7v19.13l1.445-.962a1 1 0 0 1 .873-.116l.121.05.116.066L11 26.797l2.445-1.63a1 1 0 0 1 .873-.115l.121.05.116.066L17 26.797l2.445-1.63a1 1 0 0 1 .873-.115l.121.05.116.066L22 26.13V7q0-.38.06-.715l.045-.22zM15 20a1 1 0 0 0-1-1h-4l-.117.007A1 1 0 0 0 10 21h4l.117-.007A1 1 0 0 0 15 20m3-5a1 1 0 0 1 .117 1.993L18 17h-8a1 1 0 0 1-.117-1.993L10 15zm1-3a1 1 0 0 0-1-1h-8l-.117.007A1 1 0 0 0 10 13h8l.117-.007A1 1 0 0 0 19 12"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconBillsPurchaseOrders = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconBillsPurchaseOrders);
export default Memo;
